<template>
  <div>
    <div v-if="!this.loading"
         class="card  bg-transparent">
      <div v-if="!this.display_aggrid">
        <div class="border-0 card-header bg-white">
          <h3 class="mb-0">Existing Configuration</h3>
        </div>
        <el-table class="table-responsive"
                  header-row-class-name="thead-light"
                  :data="this.tabs_config.content">
          <el-table-column label="Search"
                           min-width="150px"
                           prop="Search"
          >
            <template v-slot="{row}">
              <b>{{ row.reports[0]['ysySearchName'] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="Last run"
                           prop="Last run"
                           min-width="140px"
                           sortable>
            <template v-slot="{row}">
              <b>{{ row.reports[0]['date last run'] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="Type"
                           min-width="150px"
                           prop="Type"
          >
            <template v-slot="{row}">
              <b>{{ row.reports[0]['type'] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="sent"
                           min-width="110px"
                           prop="number_of_connections"
                           sortable>
            <template v-slot="{row}">
              <b>{{ row.reports[0]['number_of_connections'] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="accepted"
                           min-width="140px"
                           prop="accepted"
                           sortable>
            <template v-slot="{row}">
              <b>{{ row.reports[0]['accepted'] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="#Follow-up"
                           min-width="140px"
                           prop="followup"
                           sortable>
            <template v-slot="{row}">
              <b>{{ row.reports[0]['followup_sent'] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="status"
                           min-width="150px"
                           prop="status"
                           sortable>
            <template v-slot="{row}">
              <b>{{ row.reports[0]['progress_state'] }}</b>
            </template>
          </el-table-column>
          <el-table-column v-if="!$store.getters.getMaintenanceYsYSalesNavigator" label="On/Off"
                           min-width="100px"
                           prop="On/Off"
          >
            <template v-slot="{row}">

              <base-switch on-text="On" off-text="Off"
                           :key="update_key_switch"
                           :value="switchesBased[row.checked]"
                           min-width="100px"
                           @input="check((row.checked==='On' ? 'Off' : 'On'),row.reports[0],row.reports[0].id_argon)"
              ></base-switch>

            </template>
          </el-table-column>


          <el-table-column min-width="180px" align="center">
            <div slot-scope="{row}" class="table-actions">
              <el-tooltip content="Rewind your configuration" placement="top">
                <a @click.prevent="rewindConfiguration(row.reports[0])" class="table-action"
                   data-toggle="tooltip"
                   data-original-title="Rewind configuration">
                  <i class="fas fa-history"></i>
                </a>
              </el-tooltip>
              <b-spinner v-if="row.reports[0].spinner_state==='true'" small :variant="'info'"
                         :key="'info'" label="Loading..."></b-spinner>
              <el-tooltip content="Download Contact Information" placement="top">
                <a @click.prevent="exportContact(row.reports[0])" class="table-action"
                   data-toggle="tooltip"
                   data-original-title="Download Contact">
                  <i class="fas fa-file-download"></i>
                </a>
              </el-tooltip>
              <el-tooltip content="Edit" placement="top">
                <a @click.prevent="onShowConfiguration(row)" class="table-action"
                   data-toggle="tooltip"
                   data-original-title="Edit configuration">
                  <i class="fas fa-user-edit"></i>
                </a>
              </el-tooltip>
              <el-tooltip content="Archive" placement="top">
                <a @click.prevent="onDelete(row)" class="table-action table-action-delete"
                   data-toggle="tooltip"
                   data-original-title="Archive Configuration">
                  <i class="fas fa-trash"></i>
                </a>
              </el-tooltip>
              <el-tooltip content="Display Contact Information" placement="top">
                <a @click.prevent="ShowGridView(row)" class="table-action"
                   data-toggle="tooltip"
                   data-original-title="Display Contact Information">
                  <i class="fas fa-arrow-right"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>

        </el-table>
        <modal size="lg" :show.sync="stateModalConfigurationArgon" @close="closeArgonModal()">
          <template slot="header">
            <h5 class="modal-title" id="ConfigurationDetail">Configuration detail</h5>
          </template>
          <div>
            <h5 class="mb-0"> Your Search Name </h5>
            <div>
              <b-form-textarea class='text' id="searchid-plaintext" plaintext
                               :value="ysySearchNameModalConfigurationArgon">
              </b-form-textarea>
            </div>
            <h5 class="mb-0"> Your URL search </h5>
            <div>
              <b-form-textarea class='text' id="searchid-plaintext" plaintext
                               :value="SearchUrlModalConfigurationArgon">
              </b-form-textarea>
            </div>

            <div class="accordion" role="tablist"
                 v-if="ysyScheduleModalConfigurationArgon.length>0">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-1 style="background-color: dodgerblue !important;">Your
                    Configuration Schedule
                  </b-button>
                </b-card-header>

                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                  <!--                  <p>Timezone : {{ysyTimeZoneModalConfigurationArgon}}</p>-->
                  <b-card-body>
                    <b-table striped hover :items="ysyScheduleModalConfigurationArgon"></b-table>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <h5 class="mb-0"> Your {{ UserCrm }} token </h5>
            <div v-if="!editing['pipedrive token']">
              <b-form-textarea class='text' id="pipedrive-plaintext" plaintext
                               :value="TokenModalConfigurationArgon"
                               @click="enableEditing('pipedrive token')">
              </b-form-textarea>
            </div>
            <div v-if="editing['pipedrive token']">
              <base-input v-model="tempValue" input-classes="form-control-lg"
                          placeholder=".form-control-lg"/>

              <base-button type="secondary" @click="disableEditing('pipedrive token')"> Cancel
              </base-button>
              <base-button type="success" @click="saveEdit('pipedrive token')"> Save
                <b-spinner v-if=spinner_save_edit small :variant="'warning'"
                           :key="'warning'" label="Loading..."/>
              </base-button>
            </div>

            <h5 class="mb-0"> Message 1 </h5>
            <div v-if="!editing['message_1']">
              <b-form-textarea class='text' id="message_1-plaintext" plaintext rows="1"
                               max-rows="8"
                               :value="Message1ModalConfigurationArgon"
                               @click="enableEditing('message_1')">
              </b-form-textarea>
            </div>
            <div v-if="editing['message_1']">
              <!--            <input v-model="tempValue" class="input"/>-->
              <textarea onkeypress="if(event.keyCode==13){return false;}" v-model="tempValue"
                        class="form-control" id="message_1Textarea1"
                        rows="5"></textarea>
              <base-button type="secondary" @click="disableEditing('message_1')"> Cancel
              </base-button>
              <base-button type="success" @click="saveEdit('message_1')"> Save
                <b-spinner v-if=spinner_save_edit small :variant="'warning'"
                           :key="'warning'" label="Loading..."/>
              </base-button>
            </div>

            <div>
              <h5 class="mb-0"> Message 2 </h5>
              <div v-if="!editing['message_2']">
                <b-form-textarea class='text' id="message_1-plaintext" plaintext
                                 :value="Message2ModalConfigurationArgon"
                                 rows="2"
                                 max-rows="8"
                                 @click="enableEditing('message_2')">
                </b-form-textarea>

              </div>
              <div v-if="editing['message_2']">
           <textarea onkeypress="if(event.keyCode==13){return false;}" v-model="tempValue"
                     class="form-control" id="message_2Textarea1"
                     rows="5"></textarea>
                <base-button type="secondary" @click="disableEditing('message_2')"> Cancel
                </base-button>
                <base-button type="success" @click="saveEdit('message_2')"> Save
                  <b-spinner v-if=spinner_save_edit small :variant="'warning'"
                             :key="'warning'" label="Loading..."/>
                </base-button>
              </div>
            </div>

            <div>
              <h5 class="mb-0">Follow up 1</h5>
              <div v-if="!editing['follow_1']">
                <b-form-textarea class='text' id="follow_1-plaintext" plaintext rows="2"
                                 max-rows="8"
                                 :value="follow1ModalConfigurationArgon"
                                 @click="enableEditing('follow_1')">
                </b-form-textarea>

              </div>
              <div v-if="editing['follow_1']">
           <textarea onkeypress="if(event.keyCode==13){return false;}" v-model="tempValue"
                     class="form-control" id="follow_1Textarea1"
                     rows="5"></textarea>
                <base-button type="secondary" @click="disableEditing('follow_1')"> Cancel
                </base-button>
                <base-button type="success" @click="saveEdit('follow_1')"> Save
                  <b-spinner v-if=spinner_save_edit small :variant="'warning'"
                             :key="'warning'" label="Loading..."/>
                </base-button>
              </div>
            </div>

            <div>
              <h5 class="mb-0">Follow up 2</h5>
              <div v-if="!editing['follow_2']">
                <b-form-textarea class='text' id="follow_2-plaintext" plaintext rows="2"
                                 max-rows="8"
                                 :value="follow2ModalConfigurationArgon"
                                 @click="enableEditing('follow_2')">
                </b-form-textarea>

              </div>
              <div v-if="editing['follow_2']">
           <textarea onkeypress="if(event.keyCode==13){return false;}" v-model="tempValue"
                     class="form-control" id="follow_2Textarea1"
                     rows="5"></textarea>
                <base-button type="secondary" @click="disableEditing('follow_2')"> Cancel
                </base-button>
                <base-button type="success" @click="saveEdit('follow_2')"> Save
                  <b-spinner v-if=spinner_save_edit small :variant="'warning'"
                             :key="'warning'" label="Loading..."/>
                </base-button>
              </div>
            </div>

            <VueLoadingButton
              aria-label="Contact information"
              class="button"
              style="background-color:green;"
              @click.native="exportContact(ReportModalConfigurationArgon)"
              :loading="isLoadingButton"
              :styled=true
            > Export contact information of the
              {{ ReportModalConfigurationArgon['accepted'] }} accepted
            </VueLoadingButton>
          </div>
          <template slot="footer">
            <base-button type="secondary" @click="closeArgonModal()">Close
            </base-button>
          </template>
        </modal>
        <modal :show.sync="checkConfigurationLimit"
               @close="checkConfigurationLimit = false"
               danger>
          <template slot="header">
            <h5 class="modal-title">Configuration Limit</h5>
          </template>
          <div>You already reached the limit of active configuration of type <span
            style="color:red;">{{ tmpModeForCheckLimit }}</span>, for the sake of your
            linkedIn
            accounts, to keep it under the radar you can only have one configuration of the same
            type
            active at once:
            <ul>
              <li>Nbr of active configuration for <i>{{ tmpModeForCheckLimit }}</i>:
                {{ actualCountConfiguration }}
              </li>
              <li>Limit for type <i>{{ tmpModeForCheckLimit }}</i>:
                {{ limit_configuration }}
              </li>
            </ul>
            <p style="font-size: 12px;padding-top: 5%;margin-bottom: -5%">Have any question on
              those
              limits? contact your <a href="mailto:support@yoursynchronicity.com">Administrator</a></p>
          </div>
          <template slot="footer">
            <base-button type="secondary" @click="checkConfigurationLimit = false">Close
            </base-button>
            <!--        <mdb-btn color="primary">Save changes</mdb-btn>-->
          </template>
        </modal>
        <!--        MODAL FOR COMFIRM ARCHIVING-->

        <modal :show.sync="confirmArchivingSearch"
               @close="confirmArchivingSearch = false"
               danger>
          <template slot="header">
            <h5 class="modal-title">Archive Search</h5>
          </template>
          <div> Are you sure that you want to archive this search ?
          </div>
          <template slot="footer">
            <base-button type="secondary" @click="confirmArchivingSearch = false">No
            </base-button>
            <base-button type="secondary" @click="archiveSearch(searchIdToArchive)">Yes
            </base-button>
          </template>
        </modal>
      </div>
      <div v-else>
        <card>
          <i class="fas fa-arrow-left fa-2x" @click="display_aggrid=false"></i>
          <display-contact-information
            :column-defs="columnDefs" :row-data="rowData">
          </display-contact-information>
        </card>
      </div>
    </div>

    <div v-if="this.loading">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

  </div>
</template>
<script>
// import users from './../users'
import {Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip} from 'element-ui'
import axios from "axios";
import VueLoadingButton from 'vue-loading-button'
import DisplayContactInformation from "./DisplayContactInformation";
import {eventBus} from '../../main'
import {refreshIdToken} from '../../util/utilsYsy'

export default {
  name: 'ConfigTableSalesLinkedIn',
  components: {
    VueLoadingButton,
    eventBus,
    DisplayContactInformation,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      spinner_save_edit: false,
      ///AgGrid//
      display_aggrid: false,
      columnDefs: [
        {
          headerName: 'Name',
          field: 'name',
          sortable: true,
          filter: true,
          checkboxSelection: true
        },
        {headerName: 'Email', field: 'email', sortable: true, filter: true},
        {headerName: 'Phone', field: 'phone', sortable: true, filter: true},
        {headerName: 'Location', field: 'location', sortable: true, filter: true},
        {headerName: 'Title', field: 'title', sortable: true, filter: true},
        {
          headerName: 'Company Name',
          field: 'companyName',
          sortable: true,
          filter: true
        },
        {
          headerName: 'Company Description',
          field: 'descriptionCompany',
          sortable: true,
          filter: true
        },
        {
          headerName: 'LinkedIn Profile',
          field: 'linkedinProfile',
          sortable: true,
          filter: true
        },
      ],
      rowData: null,
      /////////
      ///YSY///
      confirmArchivingSearch: false,
      searchIdToArchive: '',

      switchesBased:
        {
          'On':
            true, 'Off':
            false
        }
      ,
      stateModalConfigurationArgon: false,
      ysySearchNameModalConfigurationArgon: '',
      ysyScheduleModalConfigurationArgon: '',
      ysyTimeZoneModalConfigurationArgon: '',
      Message1ModalConfigurationArgon: '',
      Message2ModalConfigurationArgon: '',
      ReportModalConfigurationArgon: '',
      CheckModalConfigurationArgon: '',
      TokenModalConfigurationArgon: '',
      SearchUrlModalConfigurationArgon: '',
      follow1ModalConfigurationArgon: '',
      follow2ModalConfigurationArgon: '',
      value: '',
      update_key_switch: '',
      checkConfigurationLimit: false,
      tempValue: null,
      tmpModeForCheckLimit: '',
      limit_configuration: '',
      actualCountConfiguration: '',
      editing:
        {
          "pipedrive token": false, "message_1": false, "message_2": false,
          "follow_1": false, "follow_2": false
        }
      ,
      isLoadingButton: false,
      isStyledButton: false,
      loading: true,
      linkedin_type: 'sales',
      search_status: false,
      UserCrm: 'CRM',
      dictConfigurationLimit: this.$store.getters.getDictConfigurationLimit,
      tabs_config:
        {
          content: []
        }
      ,
      /////////
      // users,
      currentPage: 1
    }
      ;
  },
  methods: {
    refreshIdToken,
    returnUserCrm(token) {
      if (token.includes("@YSY@")) {
        let token_array = token.split("@YSY@")
        this.UserCrm = token_array[0]
        return token_array[1]
      } else {
        return token
      }
    },
    closeArgonModal() {
      this.stateModalConfigurationArgon = false;
      for (var key in this.editing) {
        this.disableEditing(key)
      }
    },

    getMapValue(obj, key) {
      if (obj.hasOwnProperty(key))
        return obj[key];
      throw new Error("Invalid map key.");
    },
    enableEditing: function (header) {
      for (var key in this.editing) {
        this.disableEditing(key)
      }

      if (header === 'pipedrive token') {
        this.tempValue = this.returnUserCrm(this.ReportModalConfigurationArgon[header])
      } else {
        this.tempValue = this.ReportModalConfigurationArgon[header];
      }
      this.editing[header] = true;

    },
    disableEditing: function (header) {
      this.tempValue = null;
      this.editing[header] = false;
    },
    async saveEdit(header) {
      let path = this.BACKEND_YSY + "/linkedin/get-user-configuration";
      let payload;
      if (header === 'pipedrive token') {
        payload = {
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          search_id: this.ReportModalConfigurationArgon['saved_search_Id'],
          crm_token: this.tempValue === "" ? "NaN_no_need" : (this.UserCrm !== 'CRM' ? this.UserCrm + '@YSY@' + this.tempValue : this.tempValue),
          crmUpdate: 'true',
        }
      } else {
        path = this.BACKEND_YSY + "/linkedin/initState";
        payload = {
          email_linkedin: this.$store.getters.getEmailLinkedin,
          linkedin_type: this.linkedin_type,
          ysySearchName: this.ReportModalConfigurationArgon['ysySearchName'],
          url_linkedin_search: this.ReportModalConfigurationArgon['saved_search_Id'],
          crm_token: this.ReportModalConfigurationArgon['pipedrive token'],
          mode: this.ReportModalConfigurationArgon["type"],
          date_threshold: this.ReportModalConfigurationArgon['date_threshold'],
          messageUpdate: 'true'
        };

        if (header === 'message_1') {
          payload['body_message'] = [this.tempValue, this.ReportModalConfigurationArgon['message_2']];
          payload['body_follow'] = [this.ReportModalConfigurationArgon['follow_1'], this.ReportModalConfigurationArgon['follow_2']];

        } else if (header === 'message_2') {
          payload['body_message'] = [this.ReportModalConfigurationArgon['message_1'], this.tempValue];
          payload['body_follow'] = [this.ReportModalConfigurationArgon['follow_1'], this.ReportModalConfigurationArgon['follow_2']];

        } else if (header === 'follow_1') {
          payload['body_message'] = [this.ReportModalConfigurationArgon['message_1'], this.ReportModalConfigurationArgon['message_2']];
          payload['body_follow'] = [this.tempValue, this.ReportModalConfigurationArgon['follow_2']];
        } else if (header === 'follow_2') {
          payload['body_message'] = [this.ReportModalConfigurationArgon['message_1'], this.ReportModalConfigurationArgon['message_2']];
          payload['body_follow'] = [this.ReportModalConfigurationArgon['follow_1'], this.tempValue];
        }
      }

      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      this.spinner_save_edit = true
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          this.ReportModalConfigurationArgon[header] = this.tempValue;
          if (header === 'pipedrive token') {
            this.TokenModalConfigurationArgon = this.tempValue;
          }
          if (header === 'message_1') {
            this.Message1ModalConfigurationArgon = this.tempValue;
          }
          if (header === 'message_2') {
            this.Message2ModalConfigurationArgon = this.tempValue;
          }
          if (header === 'follow_1') {
            this.follow1ModalConfigurationArgon = this.tempValue;
          }
          if (header === 'follow_2') {
            this.follow2ModalConfigurationArgon = this.tempValue;
          }
          this.spinner_save_edit = false
          this.disableEditing(header);
        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.saveEdit(header)
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });
    },
    rewindConfiguration(report) {
      const path = "https://api.yoursynchronicity.com/linkedin/get-user-configuration";
      this.$http
        .post(path, JSON.stringify({
          ysy_username: this.$store.getters.getUser,
          username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          saved_search_id: report['saved_search_Id'],
          rewind: 'true'
        }), {
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.id_token}`
          }
        })
        .then(res => {
          console.log(res)
          this.$notify({
            message:
              '<b>Congratulation. You configuration will start from the first page again, turn it "ON" to start</b>',
            timeout: 6000,
            icon: 'ni ni-bell-55',
            type: "success"
          })
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.$router.push({name: 'login'});
        });

    },
    async exportContact(report) {
      const path = this.BACKEND_YSY + "/download-contacts";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      this.isLoadingButton = true;
      report["spinner_state"] = 'true';
      await this.$http
        .post(path, {
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          saved_search_id: report['saved_search_Id'],
          contact_type: "linkedin",
          download: true,
        }, {headers})
        .then(res => {

          let fileLink = document.createElement('a');
          fileLink.href = res.data[Object.keys(res.data)[0]];
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoadingButton = false;
          report["spinner_state"] = 'false';
        })
        .catch(async error => {
          const self = this;

          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.exportContact(report)
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    check(event, report, index) {
      if (event === 'On' && this.tabs_config.content[index]['checked'] === 'Off') {
        const mode = report['type']
        console.log('--------', this.dictConfigurationLimit[mode])
        if (this.dictConfigurationLimit[mode]['count'] >= this.dictConfigurationLimit[mode]['limit']) {
          this.tmpModeForCheckLimit = mode;
          this.actualCountConfiguration = this.dictConfigurationLimit[mode]['count'];
          this.limit_configuration = this.dictConfigurationLimit[mode]['limit'];
          console.log('Rejecting the demand');
          this.checkConfigurationLimit = true;
          this.tabs_config.content[index]['checked'] = 'Off'
          this.update_key_switch = Date.now()
          return
        }
        this.$store.commit('changeDictConfigurationLimit', {
          'mode': mode,
          'previous': this.dictConfigurationLimit[mode].count,
          'rule': '+'
        });
        this.checkResume(report, index)
      }
      if (event === 'Off' && this.tabs_config.content[index]['checked'] === 'On') {
        console.log('offf')
        this.$store.commit('changeDictConfigurationLimit', {
          'mode': this.tabs_config.content[index].reports[0]['type'],
          'previous': this.dictConfigurationLimit[this.tabs_config.content[index].reports[0]['type']].count,
          'rule': '-'
        })
        this.checkPause(report, index)
      }
    },
    checkResume(report, index) {
      console.log(report, index)
      this.tabs_config.content[index].reports[0]['search_state'] = 'active'
      this.controlStateSearch(this.tabs_config.content[index].reports[0]['saved_search_Id'], 'active')
      this.tabs_config.content[index]['checked'] = 'On'
    },
    checkPause(report, index) {
      console.log(report, index)
      this.tabs_config.content[index].reports[0]['search_state'] = 'not_active'
      this.controlStateSearch(this.tabs_config.content[index].reports[0]['saved_search_Id'], 'not_active')
      this.tabs_config.content[index]['checked'] = 'Off'
    },
    async controlStateSearch(savedSearchId, state) {
      const path = this.BACKEND_YSY + "/linkedin/control-state-search";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      await this.$http
        .post(path, {
          id_token: localStorage.id_token,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          saved_search_id: savedSearchId,
          state: state,
        }, {headers})
        .then(async res => {
          console.log('res', res)
        })
        .catch(async error => {
          // eslint-disable-next-line
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.controlStateSearch(savedSearchId, state)
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });
    },
    async archiveSearch(saved_search_Id) {
      const path = this.BACKEND_YSY + "/linkedin/get-user-configuration";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      await this.$http
        .post(path, {
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          search_id: saved_search_Id,
          archive: true
        }, {headers})
        .then(res => {
          console.log('State deleted', res.data);
          this.confirmArchivingSearch = false;
          location.reload()
        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.archiveSearch(saved_search_Id)
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        })
    },
    async getMessageConfig() {
      const path = this.BACKEND_YSY + "/linkedin/get-user-configuration";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      await this.$http
        .post(path, {
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          linkedin_type: this.linkedin_type,
        }, {headers})
        .then(res => {
          console.log(res);
          if (res.data.search_status === 404) {
            this.search_status = false;
            this.loading = false;
            return
          }
          if (res.status === 200) {
            for (let i = 0; i < Object.keys(res.data).length; i++) {
              if (res.data[i]['reports'][0]['search_state'] === 'active') {
                res.data[i]['checked'] = 'On';
                this.tabs_config.content.push(res.data[i]);
              }
              if (res.data[i]['reports'][0]['search_state'] === 'not_active') {
                res.data[i]['checked'] = 'Off';
                this.tabs_config.content.push(res.data[i]);
              }
            }
            this.loading = false;
            this.search_status = true;
          }

        })
        .catch(async error => {
          // eslint-disable-next-line
          console.error(error);
          var self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.getMessageConfig()
            }, function (err) {
              console.log("it broke, relog", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    onShowConfiguration(row) {
      console.log("myrow", row.reports[0])
      this.stateModalConfigurationArgon = true;
      this.Message1ModalConfigurationArgon = row.reports[0].message_1;
      this.Message2ModalConfigurationArgon = row.reports[0].message_2;
      this.follow1ModalConfigurationArgon = row.reports[0].follow_1;
      this.follow2ModalConfigurationArgon = row.reports[0].follow_2;
      this.SearchUrlModalConfigurationArgon = row.reports[0].saved_search_Id;
      this.ysySearchNameModalConfigurationArgon = row.reports[0].ysySearchName;
      this.ysyScheduleModalConfigurationArgon = row.reports[0].configuration_schedule;
      this.ysyTimeZoneModalConfigurationArgon = row.reports[0].timezone_configuration;
      this.TokenModalConfigurationArgon = this.returnUserCrm(row.reports[0]['pipedrive token']);
      this.ReportModalConfigurationArgon = row.reports[0];
      console.log(this.ReportModalConfigurationArgon)

    },
    onDelete(row) {
      console.log(row['searchId']);
      this.searchIdToArchive = row['searchId'];
      this.confirmArchivingSearch = true;

    },
    ShowGridView(row) {
      if (localStorage.contact_information) {
        let TmpContactInformation = JSON.parse(localStorage.contact_information);
        this.rowData = TmpContactInformation[row['searchId']];
        this.display_aggrid = true;
        return
      }
      let path = this.BACKEND_YSY + "/linkedin/get-user-configuration";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      this.$http
        .post(path, {
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          AgGridVue: true,
        }, {headers})
        .then(res => {
          localStorage.contact_information = JSON.stringify(res.data);
          this.rowData = res.data[row['searchId']];
          eventBus.$emit('rowDataAgGrid', this.rowData);

        })
        .catch(error => {
          // eslint-disable-next-line
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            self.$router.push({name: 'login'});
          }
        });
      this.display_aggrid = true;
    },
  },
  created() {
    this.dictConfigurationLimit = this.$store.getters.getDictConfigurationLimit
    this.getMessageConfig();
    console.log(this.tabs_config)
  }
};
</script>
